<template lang="pug">
.content-center
  .overlay(@click="hide()")
  .item-group.mb-2
    ul.p-0.m-0
      li.item-single.d-flex.px-3
        .value.w-50 {{ $t("ui.account_id") }}
        .detail.w-50.grey {{ account_id }}
      template(v-if="!whiteLabel")
        li.item-single.d-flex.px-3(v-if="nickname != null")
          .value.w-50 {{ $t("ui.nickname") }}
          .detail.w-50.grey {{ nickname }}
        li.item-single.d-flex.px-3(v-else data-bs-toggle="modal" data-bs-target="#nickname")
          .value.w-50 {{ $t("ui.nickname") }}
          .detail.w-50.grey
            i.fas.fa-pen
  .item-group.mb-2
    ul.p-0.m-0
      li.item-single.d-flex.px-3
        .value.w-50 {{ $t("ui.currency") }}
        .detail.w-50.grey {{ currency_code }}
      li.item-single.d-flex.px-3
        .value.w-50 {{ $t("ui.cash_balance") }}
        .detail.w-50(:class="{ 'text-danger' : parseFloat(cash_balance) < 0 }") {{ cash_balance }}
      li.item-single.d-flex.px-3
        .value.w-50 {{ $t("ui.outstanding") }}
        .detail.w-50(:class="{ 'text-danger' : parseFloat(frozen_balance) < 0 }") {{ frozen_balance }}
      li.item-single.d-flex.px-3(v-if="operatorType == 1")
        .value.w-50 {{ $t("ui.bet_credit") }}
        .detail.w-50(:class="{ 'text-danger' : parseFloat(available_balance) < 0 }") {{ available_balance }}
      li.item-single.d-flex.px-3(v-if="!whiteLabel")
        .value.w-50 {{ $t("ui.given_credit") }}
        .detail.w-50(:class="{ 'text-danger' : parseFloat(given_credit) < 0 }") {{ given_credit }}
  .item-group.mb-2
    ul.p-0.m-0
      li.item-single.d-flex.px-3
        .value.w-50 {{ $t("ui.last_login") }}
        .detail.w-50.grey {{ last_login_time }}
</template>

<script>
import config from "@/config";

export default {
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    account_id() {
      return this.$store.getters.accountId;
    },
    nickname() {
      return this.$store.getters.nickName;
    },
    operatorType() {
      return this.$store.getters.operatorType;
    },
    last_login_time() {
      if (this.$store.getters.playerInfo != null) {
        if (this.$store.getters.playerInfo.last_login_time != null) {
          return this.$dayjs(this.$store.getters.playerInfo.last_login_time).format("MM/DD/YY hh:mm:ss A");
        }
      }
      return null;
    },
    wallet() {
      if (this.$store.getters.playerWallet) return this.$store.getters.playerWallet;
      return null;
    },
    balance() {
      return this.$store.getters.balance;
    },
    currency_code() {
      if (this.wallet["currency_code"]) {
        return this.wallet.currency_code.replace('UST', 'USDT');
      }
      return "-";
    },
    available_balance() {
      if (this.wallet) {
        return this.$numeral(this.wallet.available_balance).format("0,0.[00]");
      }
      return "-";
    },
    cash_balance() {
      if (this.wallet) {
        return this.$numeral(this.wallet.cash_balance).format("0,0.[00]");
      }
      return "-";
    },
    frozen_balance() {
      if (this.wallet) {
        return this.$numeral(this.wallet.frozen_balance).format("0,0.[00]");
      }
      return "-";
    },
    given_credit() {
      if (this.wallet) {
        return this.$numeral(this.wallet.credit_limit).format("0,0.[00]");
      }
      return "-";
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    }
  }
};
</script>
  